import fetch from "auth/FetchInterceptor";

export const CouponService = {};

CouponService.get = async ({
  page,
  pageSize,
  sort,
  searchText,
  state = null,
  isPublic = 0,
}) => {
  let apiUrl = "/v1/coupon?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Did";
  else if (sort === "descend") apiUrl += "&order_by=%2Bid";
  if (searchText) apiUrl += "&name=" + searchText;
  if (state) {
    apiUrl += "&state=" + state;
  }
  apiUrl += "&public=" + isPublic;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

CouponService.getById = async (id) => {
  const apiUrl = `/v1/coupon/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

CouponService.createCoupon = async (data) => {
  const apiUrl = `/v1/coupon`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

CouponService.updateCoupon = async (data) => {
  const apiUrl = `/v1/coupon/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

CouponService.patchCoupon = async (id, data) => {
  return fetch({
    url: `/v1/coupon/${id}`,
    method: "patch",
    data,
  });
};

CouponService.updateCouponGroup = async (id, data) => {
  return fetch({
    url: `/v1/coupon/group/${id}`,
    method: "put",
    data,
  });
};

CouponService.deleteCouponGroup = async (id) => {
  return fetch({
    url: `/v1/coupon/group/${id}`,
    method: "delete",
  });
};

CouponService.deleteCoupon = async (id) => {
  const apiUrl = `/v1/coupon/${id}`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

CouponService.getTemplate = async () => {
  const apiUrl = `/v1/coupon/bulk/template`;
  return fetch({
    url: apiUrl,
    method: "get",
    responseType: "blob",
  });
};

CouponService.createBulkCoupon = async (data) => {
  const form_data = new FormData();
  form_data.append("template", data.template);
  return fetch({
    url: "/v1/coupon/bulk",
    method: "post",
    data: form_data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export default CouponService;
